<template>
  <div class="miya-purchaseTraffic" id="miya-purchaseTraffic" @click="showPayBox = false">
    <div class="pageBox">
      <h1 class="title1 fontSH">{{$t('pTraffic.title1')}}</h1>
      <div class="select-card">
        <div class="cardBtns" v-if="pageWidth < 800">
          <el-button class="country" @click.stop="changeNum('country')" :type="activeIdx === 'country' ? 'primary': 'info'" size="medium" plain>{{$t('dashboard.titleCountry')}}</el-button>
          <el-button class="city" @click.stop="changeNum('city')" :type="activeIdx === 'city' ? 'primary': 'info'" size="medium" plain>{{$t('dashboard.titleCity')}}</el-button>
        </div>
        <div class="card-box">
          <div class="item country" :class="{active: activeIdx === 'country'}" @click.stop="changeNum('country')">
            <div class="row">{{dataList[0].name}}</div>
            <div class="row p-row"><span class="usd">$</span><span class="price">{{dataList[0].price}}.00</span><span class="unit">/G</span></div>
            <div class="row" v-for="(item, idx) in dataList[0].list" :key="'text'+idx">{{item}}</div>
            <div class="row">
              <el-input-number size="medium" v-model="dataList[0].num" :step="1" :precision="0" :min="1" :max="100" :step-strictly="true" @change="changeNum('country')"></el-input-number>
              <span class="gb">GB</span>
              <p class="dataTip">{{$t('pTraffic.max100')}}</p>
            </div>
            <div class="buyFlag" v-show="activeIdx === 'country'">
              <img class="flag" src="@assets/images/dynamic/buy-country.png">
              <span class="name">{{$t('pTraffic.buyIt')}}</span>
            </div>
            <div class="shadow" v-show="activeIdx === 'city'"></div>
          </div>
          <div class="name-box">
            <div class="row" v-for="(item, idx) in nameList" :key="'name'+idx" :class="{dip: idx===4 && language == 'EN', dip1: idx===4}">{{item}}</div>
          </div>
          <div class="item city" :class="{active: activeIdx === 'city'}" @click.stop="changeNum('city')">
            <div class="row">{{dataList[1].name}}</div>
            <div class="row p-row"><span class="usd">$</span><span class="price">{{dataList[1].price}}.00</span><span class="unit">/G</span></div>
            <div class="row" v-for="(item, idx) in dataList[1].list" :key="'text'+idx">{{item}}</div>
            <div class="row">
              <el-input-number size="medium" v-model="dataList[1].num" :step="1" :precision="0" :min="1" :max="100" :step-strictly="true" @change="changeNum('city')"></el-input-number>
              <span class="gb">GB</span>
              <p class="dataTip">{{$t('pTraffic.max100')}}</p>
            </div>
            <div class="buyFlag" v-show="activeIdx === 'city'">
              <img class="flag" src="@assets/images/dynamic/buy-city.png">
              <span class="name">{{$t('pTraffic.buyIt')}}</span>
            </div>
            <div class="shadow" v-show="activeIdx === 'country'"></div>
          </div>
        </div>
        <div class="contact">
          <img class="bg" src="@assets/images/dynamic/bg1.png">
          <p class="name">{{$t('home.pContact')}}</p>
          <div class="btn"><el-button type="info" class="miyaBtnInfo" size="medium" plain @click="dialogTableContact = true">{{$t('pTraffic.btnLearn')}}</el-button></div>
        </div>
      </div>
      <div class="select-value">
        <p v-if="activeIdx==''" class="noSelect">{{$t('pTraffic.noSelect')}}</p>
        <img v-show="activeIdx === 'country'" class="icon" src="@assets/images/home/price-icon1.png">
        <img v-show="activeIdx === 'city'" class="icon" src="@assets/images/home/price-icon2.png">
        <p class="select" v-if="activeIdx">{{$t('pTraffic.selectStr')}}<span class="highlight">{{activeIdx === 'country' ? ` ${$t('home.pSubtitile1_1')}` : activeIdx === 'city' ? ` ${$t('home.pSubtitile2_1')}` : ''}}</span></p>
        <span v-if="activeIdx"><span class="name">{{$t('pTraffic.pTraffic')}}</span><span class="num">{{num}}</span><span class="unit">[GB]</span></span>
      </div>
      <div class="price-box" >
        <div class="discountCode">
          <label class="label">{{$t('pTraffic.discountCode')}}</label>
          <el-input size="medium" style="width:280px;" :class="{error: discountCodeError}" clearable @clear="clearDiscountCode()" :placeholder="$t('pTraffic.placeholderDc')" v-model="discountCode" @change="changeDc()"></el-input>
          <p class="discountCodeError" v-show="discountCodeError">{{discountCodeError}}</p>
        </div>
        <div class="price">
          <p class="amountLabel">{{$t('pTraffic.amount')}}</p>
          <p class="usd">$</p>
          <p class="amount">{{amount}}</p>
          <p class="old" v-show="discountCode && !discountCodeError">${{oldAmount}}</p>
        </div>
        <div class="btns">
          <div class="info-btn">
            <el-button style="width: 100%;border-radius:0;" type="info" @click="clickUSDT()">{{$t('pTraffic.btnUsdt')}}</el-button>
          </div>
          <miya-btn class="payBtn" ref="miyaBtn1" :title="$t('pTraffic.otherPay')" @hover="showPayBox = true" @click="clickPayBtn()">
            <template slot="icon">
              <i class="icon-caret" :class="showPayBox ? 'el-icon-caret-bottom': 'el-icon-caret-top'"></i>
            </template>            
          </miya-btn>
          <div class="pay-box" v-show="showPayBox" @mouseout.stop="showPayBox=false">
            <div class="pay-box1" @mouseover="showPayBox=true">
              <div class="item" @click.stop="clickPay('alipay')"><img class="icon" src="@assets/images/dynamic/zfb.png"><span>{{$t('pTraffic.Alipay')}}</span><div class="line"></div></div>
              <div class="item" @click.stop="clickPay('native')"><img class="icon" src="@assets/images/dynamic/vx.png"><span>{{$t('pTraffic.WeChat')}}</span><div class="line"></div></div>
              <div class="item" @click.stop="clickPay('adyen')"><img class="other1" src="@assets/images/dynamic/other1.png"></div>
              <div class="item" @click.stop="clickPay('paypal')"><img class="other1" src="@assets/images/dynamic/pp_fc_hl.svg"></div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :title="$t('pTraffic.contactTitle')" :visible.sync="dialogTableContact" width="240px">
        <img class="vx" src="@assets/images/login/vx.png">
        <br/>
        <br/>
      </el-dialog>
      <el-dialog :title="loadQr ? '' : $t('pTraffic.payUSDT')" :visible.sync="dialogTableUSDT" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" :width="loadQr?'240px':'360px'">
        <div class="qrImg" v-show="loadQr">
          <img class="loading" src="@assets/images/home/load.gif">
          <p class="text">{{$t('pTraffic.loading')}}</p>
        </div>
        <div class="usdt-box" v-if="!loadQr">
          <p class="usdt"><span class="value">{{USDT}}</span><span class="unit">USDT</span></p>
          <p class="old" v-show="discount < 1"><span class="value">{{oldUSDT}}</span><span class="unit">USDT</span></p>
        </div>
        <div class="dialog-footer" v-if="!loadQr">
          <el-button class="ok" type="info" size="medium" :disabled="usdtSurplus < USDT" @click.stop="clickPayUSDT()">{{usdtSurplus < USDT ? $t('login.balance1') : $t('pTraffic.payOk')}}</el-button>
          <div class="cancel-usdt"><span @click.stop="dialogTableUSDT = false">{{$t('pTraffic.payCancel')}}</span></div>
        </div>
      </el-dialog>
      <el-dialog :title="payTitle" :visible.sync="dialogTablePayCode" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" :width="loadQr?'240px':'360px'">
        <div class="qrImg" v-show="loadQr">
          <img class="loading" src="@assets/images/home/load.gif">
          <p class="text">{{$t('pTraffic.loading')}}</p>
        </div>
        <div class="qrImg" v-if="!loadQr">
          <img class="qrcode" :src="payQr">
        </div>
        <div class="pay-dialog-price" v-if="!loadQr">
          <label class="name">{{$t('pTraffic.amount')}}</label>
          <span class="old" v-show="discount < 1">￥{{odlAmountRMB}}</span>
          <span class="unit">￥</span>
          <span class="amount">{{amountRMB}}</span>
        </div>
        <div class="pay-footer" v-if="!loadQr">
          <el-button class="cancel miyaBtnInfo" type="info" size="medium" plain @click.stop="dialogTablePayCode = false">{{$t('pTraffic.payCancel')}}</el-button>
          <el-button class="ok" type="info" size="medium" @click.stop="$router.push('/historicalOrders')">{{$t('pTraffic.paid')}}</el-button>
        </div>
      </el-dialog>
      <el-dialog class="dialogAdyen" :show-close="false" :visible.sync="dialogAdyen" :modal-append-to-body="false" :close-on-click-modal="false" :close-on-press-escape="false" :width="pageWidth < 900 ? '90%' : '900px'" :top="pageWidth < 900 ? '5vh' : '10vh'">
        <div class="adyenContent">
          <div class="close" @click="dialogAdyen=false"><i class="el-icon-close"></i></div>
          <div class="dropin-container" id="dropin-container"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import miyaBtn from '@components/miyaBtn.vue'
import AdyenCheckout from '@adyen/adyen-web';
export default {
  data () {
    return {
      dataList: [
        { id: 'country', name: '', price: 8, num: 1, list: []},
        { id: 'city', name: '', price: 12, num: 1, list: []},
      ],
      nameList: [],
      num: 1,
      amount: 0,
      oldAmount: 0,
      discount: 1,
      discountCode: '',
      activeIdx: '',
      priceTop: 0,
      USDT: 0,
      oldUSDT: 0,
      dialogTableContact: false,
      showPayBox: false,
      dialogTableUSDT: false,
      dialogTablePayCode: false,
      amountRMB: 0,
      odlAmountRMB: 0,
      payQr: '',
      discountCodeError: '',
      loadQr: false,
      payType: '',
      orderId: '',
      dialogAdyen: false,
    }
  },
  created () {
    let query = this.$route.query
    if (query && query.type) {
      this.activeIdx = query.type === 'country' ? 'country' : 'city'
      let obj = this.dataList.find(val => {return val.id === this.activeIdx})
      this.amount = this.oldAmount = this.num * obj.price
    }
  },
  computed: {
    usdtSurplus () {
      return this.user.usdtSurplus || 0
    },
    payTitle () {
      if (this.loadQr) {
        return ''
      } else {
        let type = ''
        if (this.payType === 'alipay') {
          type = this.$t('pTraffic.Alipay')
        } else if (this.payType === 'native') {
          type = this.$t('pTraffic.WeChat')
        }
        return `${type}${this.$t('pTraffic.payCode')}`
      }
    },
    ...mapGetters(['user', 'language'])
  },
  mounted () {  
    this.getData()
    if (this.pageWidth < 800 && !this.activeIdx) {
      this.changeNum('country')
    }
  },
  methods: {
    getData () {
      this.nameList = []
      this.dataList[0].list = []
      this.dataList[1].list = []
      for(let i = 1; i < 10; i++) {
        this.nameList.push(this.$t(`pTraffic.name${i}`))
        if (i < 7) {
          this.dataList[0].list.push(this.$t(`pTraffic.option${i}`))
          this.dataList[1].list.push(this.$t(`pTraffic.option2${i}`))
        }
      }
      this.dataList[0].name = this.$t(`dashboard.titleCountry`)
      this.dataList[1].name = this.$t(`dashboard.titleCity`)
    },
    changeNum (type) {
      this.activeIdx = type
      let obj = this.dataList.find(val => {return val.id === type})
      this.num = obj.num
      this.oldAmount =  this.num * obj.price
      this.amount = Number((this.oldAmount * this.discount).toFixed(2))
    },
    clearDiscountCode () {
      if (this.activeIdx) {
        this.changeNum(this.activeIdx)
      }
    },
    clickPay (type) { // 其他支付
      // if (type === 'adyen') {
      //   this.$message.warning(this.$t('pTraffic.commingSoon'))
      //   return
      // }
      if (this.activeIdx) {
        this.showPayBox = false
        this.dialogTablePayCode = true
        this.payType = type
        let data = {
          payType: type,
          shopType: this.activeIdx === 'country' ? 'resicountry' : 'resicity',
          mealnum: this.num,
          discountKey: this.discountCode, // miya6zhe
        }
        this.loadQr = true
        this.$get(`/ProxyBuy/Get`, data).then(res => {
          this.loadQr = false
          if (res.code === 200) {
          if (this.payType === 'adyen') {
            this.loadQr = true
            this.getConfiguration(res.result.checkoutSessionid, res.result.sessionData)
          } else if (this.payType === 'paypal') {
            window.open(res.result.sessionData, '_blank')
          }else {
            this.payQr = res.result.qr
          }
            this.amountRMB = res.result.price
            this.odlAmountRMB = Number((res.result.price / this.discount).toFixed(2))
          } else {
            this.dialogTablePayCode = false
            this.$message.error(res.message)
          }
        })
      } else {
        this.$message.error(this.$t('pTraffic.selectType'))
      }    
    },
    async getConfiguration (sessionid, sessionData) {
      const configuration = {
        environment: 'live', // Change to 'live' for the live environment.
        clientKey: 'live_OX724TTSUZG7ZE5KUZF3EBMXRILZHW73', // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
        analytics: {
          enabled: true // Set to false to not send analytics data to Adyen.
        },
        session: {
          id: sessionid, // Unique identifier for the payment session.
          sessionData: sessionData // The payment session data.
        },
        onPaymentCompleted: (result, component) => {
          console.info(result, component);
        },
        onError: (error, component) => {
          console.error(error.name, error.message, error.stack, component);
        },
        // Any payment method specific configuration. Find the configuration specific to each payment method:  https://docs.adyen.com/payment-methods
        // For example, this is 3D Secure configuration for cards:
        paymentMethodsConfiguration: {
          card: {
            hasHolderName: true,
            holderNameRequired: true,
            billingAddressRequired: true
          }
        }
      };
      const checkout = await AdyenCheckout(configuration)
      
      this.loadQr = false
      this.dialogTablePayCode = false
      this.dialogAdyen = true
      this.$nextTick(() => {
        const dropinComponent = checkout.create('dropin').mount('#dropin-container');
        dropinComponent.update();
      })
    },
    clickUSDT () {
      if (this.activeIdx) {
        let data = {
          payType: 'usdt',
          shopType: this.activeIdx === 'country' ? 'resicountry' : 'resicity',
          mealnum: this.num,
          discountKey: this.discountCode,
          realPay: 0,
        }
        this.dialogTableUSDT = true
        this.loadQr = true
        this.$get(`/ProxyBuy/Get`, data).then(res => {
          this.loadQr = false
          if (res.code === 200) {
            // this.orderId = res.result.orderId
            this.USDT = res.result.priceDao
            this.oldUSDT = Number((res.result.priceDao / this.discount).toFixed(2))
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        this.$message.error(this.$t('pTraffic.selectType'))
      }      
    },
    clickPayUSDT () { // USDT支付
      let data = {
        payType: 'usdt',
        shopType: this.activeIdx === 'country' ? 'resicountry' : 'resicity',
        mealnum: this.num,
        discountKey: this.discountCode,
        realPay: 1,
      }
      this.loadQr = true
      this.$get(`/ProxyBuy/Get`, data).then(res => {
        if (res.code === 200) {
          this.orderId = res.result.orderId
          this.$get(`/ProxyBuy/UsdtCallback?orderId=${this.orderId}`).then(res1 => {
            this.loadQr = false
            this.dialogTableUSDT = false
            if (res1.code === 200) {
              this.$message.success(this.$t('login.success'))
              setTimeout(() => {
                this.$get(`/Check/GetInfo`).then(res2 => {
                  if (res2.code === 200) {
                    this.$store.commit('set_user', res2.result)
                  }
                })
              }, 200);
            } else {
              this.$message.error(res1.message)
            }
          })
        } else {
          this.loadQr = false
          this.dialogTableUSDT = false
          this.$message.error(res.message)
        }
      })
    },
    changeDc () { // 获取折扣码
      if (this.discountCode) {
        this.$get(`/ProxyBuy/DiscountInfo?discountKey=${this.discountCode}`).then(res => {
          if (res.code === 200) {
            this.discount = Number(res.result)
            if (this.activeIdx) {
              this.changeNum(this.activeIdx)
            }          
            this.discountCodeError = ''
          } else if (res.code === 500) {
            this.discountCodeError = this.$t('pTraffic.discountCodeError')
          }
        })
      }
    },
    clickPayBtn () {
      if (this.pageWidth < 800 && !this.showPayBox) {
        this.showPayBox = true
      }
    }
  },
  watch: {
    language () {
      this.getData()
    },
    discountCode () {
      if (this.discountCode.length === 0) {
        this.discountCodeError = ''
      }      
    }
  },
  components: {miyaBtn}
}
</script>
<style scoped lang="stylus">
.miya-purchaseTraffic
  height 100%
  overflow-y hidden
  .pageBox
    min-height 100%
    padding 40px 40px 24px 40px
    position relative
  .title1
    color $c1
    font-size 28px
    margin 10px 0 32px 0
  .select-card
    display flex
    .card-box
      flex 1
      display flex
      text-align center
      .item
        flex 1
        border 1px solid $c4
        position relative
        .shadow
          position absolute
          top 0
          width 36px
          height 100%           
        .row
          line-height 24px
          min-height 56px
          padding 16px
          font-size $f14
          color $c2
          background-color $c7
          position relative
          &:nth-of-type(2n+1)
            background-color #F5F6F7
          &:nth-of-type(1)
            fontWeight()
            font-size $f16
            border-radius 0 5px 0 0
            background-color #EBEBEB
          &:nth-of-type(3)
            border-top 1px solid $c4
          &:nth-of-type(9)
            height auto
            border-top 1px solid $c4
            background-color $c7
            border-radius 0 0 5px 0
            .dataTip
              color $c3
          .el-input-number--medium
            width 60%
          .gb
            margin-left 8px
            position absolute
            top 34px
        .p-row
          height auto
          .usd
            font-size $f20
            position relative
            top -3px
            fontWeight()
            margin-right 8px
          .price
            font-size 36px
            line-height 40px
            fontWeight()
          .unit
            font-size $f20
        &:nth-of-type(1)
          border-right none
          border-radius 5px 0 0 5px
        &:nth-of-type(3)
          border-left none
          border-radius 0 5px 5px 0
        &:hover
          .row
            color $c1
      .country
        cursor pointer
        .shadow
          right 0          
          background: linear-gradient(270deg, rgba(122,122,122,0.8) 0%, rgba(122,122,122,0.3) 40%, rgba(255,255,255,0) 100%); 
          opacity 0.4
        .row
          &:nth-of-type(1)
            border-radius 5px 0 0 0
          &:nth-of-type(9)
            border-radius 0 0 0 5px
      .city
        cursor pointer
        .shadow
          left 0
          background: linear-gradient(270deg, rgba(255,255,255,0) 0%, rgba(122,122,122,0.3) 40%, rgba(122,122,122,0.8) 100%);   
          opacity 0.4
      .active
        border 1px solid $c8
        .row
          color $c8
          &:nth-of-type(2n+1)
            background-color #FFF6EC
          &:nth-of-type(1)
            color $c1
            background-color #FFD29F
          &:nth-of-type(3)
            border-top 1px solid $c8
          &:nth-of-type(9)
            background-color $c7
            border-top 1px solid $c8
            color $c1
        &:hover
          .row
            color $c8
            &:nth-of-type(1)
              color $c1
            &:nth-of-type(9)
              color $c1
      .country, .city
        position relative
        top 0
        .buyFlag
          position absolute
        .name
          position absolute
          font-size $f14
          color $c7
          width 100%
          text-align center
      .country
        left 0
        .buyFlag
          top -5px
          left -4px
        .name
          left -22%
          top 26%
          transform rotate(-45deg)
      .city
        right 0
        .buyFlag
          top -5px
          right -4px
        .name
          right -22%
          top 26%
          transform rotate(45deg)
      .name-box
        width 200px
        background: linear-gradient(180deg, #FF8F10 0%, #FF6F00 100%);
        .row
          line-height 24px
          height 56px
          padding 16px 0
          font-size $f16
          color $c7
          &:nth-of-type(2n)
            background-color $c71
          &:nth-of-type(2)
            height auto
            line-height 40px
          &:last-child
            line-height 61px
        .dip
          height 80px
          line-height 54px
    .contact
      width 24%
      margin-left 42px
      background-color #F5F6F7
      position relative
      overflow hidden
      display flex
      flex-direction column
      justify-content center
      .name
        font-size $f20
        color $c1
        fontWeight()
        line-height 32px
        text-align center
        width 80%
        margin 0 auto
      .bg
        position absolute
        bottom -14%
        left 0
        opacity 0.3
        z-index 0
      .btn
        z-index 3
        margin 64px auto 0 auto
  .select-value
    padding 16px
    line-height 24px
    display flex
    background-color #F5F6F7
    margin 12px 0 130px 0
    font-size $f14
    .noSelect
      color $c10
      fontWeight()
    .icon
      width 24px
    .select
      font-size $f16
      fontWeight()
      color $c1
      margin 0 40px 0 6px
      .highlight
        color $c8
    .name
      margin-right 12px
    .num
      fontWeight()
      color $c8
      line-height 20px
      font-size $f20
      margin-right 6px
  .price-box
    position absolute
    z-index 5
    left 0
    bottom 0
    width 100%
    border-top 1px solid $c4
    background-color $c7
    display flex
    .discountCode
      position absolute
      bottom calc(100% + 12px)
      background-color $c7
      left 40px
      padding 6px 
      box-shadow: 0px 6px 16px 1px rgba(20,17,14,0.14)
      display flex
      .label
        font-size $f14
        fontWeight()
        color $c1
        line-height 36px
        margin 0 32px 0 16px
      .discountCodeError
        color $c10
        line-height 36px
        margin 0 12px 0 20px
        font-size $f12
    .price
      padding 16px 0 16px 36px
      line-height 36px
      display flex
      flex 1
      .amountLabel
        font-size $f14
        color $c1
        margin-right 20px
        position relative
        top 6px
      .usd
        color $c8
        font-size $f24
        margin-right 8px
        fontWeight()
        position relative
        top 2px
      .amount
        color $c8
        font-size 36px
        fontWeight()
        margin-right 16px
      .old
        color $c2
        font-size $f16
        text-decoration: line-through
        position relative
        top 6px
    .btns
      display flex
      .info-btn
        padding 13px 0
        width 160px
      .payBtn
        margin-left 36px
        width 220px
        color $c7
        text-align center
        line-height 68px
        background: linear-gradient(95deg, #FF8F10 0%, #FF7010 100%);
        .icon-caret
          margin-left 6px
      .pay-box
        position absolute
        bottom 100%
        right 0
        width 220px
        padding-bottom 12px
        .pay-box1
          box-shadow: 0px 6px 12px 1px rgba(20,17,14,0.12)
          .item
            display flex
            height 64px
            padding 22px 
            line-height 20px
            color $c1
            font-size $f16
            background-color $c7
            position relative
            cursor pointer
            .icon
              width 20px
              margin-right 12px
            .line
              position absolute
              width calc(100% - 44px)
              height 1px
              bottom 0
              left 22px
              background-color $c4
            &:hover
              background-color #F6F6F6
            .other1
              height 24px
  .vx
    display block
    margin 0 auto
  .usdt-box
    padding 56px 0
    text-align center
    .usdt
      color $c10
      margin-bottom 24px
      .value
        font-size 40px
        margin-right 8px
      .unit
        font-size $f14
    .old
      color $c2
      position relative
      display inline-block
      margin 0 auto
      padding 0 4px
      line-height 12px
      .value
        font-size $f24
        margin-right 8px
      .unit
        font-size $f14
      &:before
        content ''
        position absolute
        width 100%
        height 1px
        background-color $c2
        top 50%
        left 0
  .pay-footer
    display flex
    padding-bottom 24px
    .ok, .cancel
      flex 1
  .dialog-footer
    padding-bottom 24px
  .pay-dialog-price
    margin 42px 0 12px 0
    display flex
    line-height 24px
    .name
      font-size $f14
      fontWeight()
      flex 1
    .old
      color $c2
      font-size $f14
      margin-right 12px
      text-decoration: line-through
    .unit
      color $c10
      font-size $f16
      margin-right 6px
    .amount
      color $c10
      font-size $f24
      position relative
      top -3px
  .qrImg
    .qrcode, .loading
      display block
      margin 0 auto
    .loading
      width 124px
      margin-top 2px
    .qrcode
      margin-top 12px
    .text
      padding 24px 0 42px 0
      text-align center
      font-size $f14
      color $c2
      line-height 22px
  .cancel-usdt
    text-align center
    color $c2
    span
      cursor pointer
      &:hover
        color $c1
  .dialogAdyen
    >>>.el-dialog
      margin 5vh auto 0 auto
    >>>.el-dialog__header
      padding 0
  .adyenContent
    position relative
    .close
      position absolute
      right -30px
      top -30px
      font-size 16px
      color #fff
      border-radius 50%
      padding 6px
      border 1px solid rgba(255,255,255,0.5)
      background-color rgba(255,255,255,0.1)
      cursor pointer
      backdrop-filter blur(5px)
@media screen and (min-width: 1986px)
  .miya-purchaseTraffic
    .select-card .card-box .name-box .dip1
      line-height 24px
      height 56px
@media screen and (max-width: 1440px)
  .miya-purchaseTraffic
    .select-card .contact
      margin-left 24px
    .select-card .card-box .name-box .dip1
      height 80px
      line-height 54px
@media screen and (max-width: 800px)
  .miya-purchaseTraffic
    overflow-y auto
    .title1
      margin-bottom 1rem
      line-height 1.5rem  
    .select-card
      display block
      .cardBtns
        display flex
        justify-content space-between
        margin-bottom 1rem
      .card-box
        .item
          display none
          .row
            font-size 0.65rem
            &:nth-of-type(1)
              font-size 0.75rem
            .el-input-number--medium
              width 80%
        .active
          display block
          .row
            &:nth-of-type(5)
              height 80px
        .name-box
          width 7rem
          .row
            font-size 0.75rem
      .contact
        margin-left 0
        width 100%
        .name
          width 90%
          font-size 0.9rem
          margin-top 1rem
        .btn
          margin 1rem auto
    .select-value
      margin 0.5rem 0 1rem 0
      padding 0.5rem
      flex-wrap wrap
    .price-box
      position relative
      display block
      border-top none
      .discountCode
        position relative
        left 0
        display block
        background-color transparent
        box-shadow none
        padding 0.5rem
        .label
          margin 0 1rem 0 0
      .price
        padding 0 0.5rem 0.5rem 0.5rem
      .btns
        display block
        .info-btn
          width 100%
          margin 1rem auto
          padding 0
        .payBtn
          margin-left 0
          width 100%
        .pay-box
          bottom 0
    .adyenContent
      position relative
      .close
        top -32px
        right -5px
</style>
<style lang="stylus">
.miya-purchaseTraffic
  .el-button--info.is-disabled, .el-button--info.is-disabled:active, .el-button--info.is-disabled:focus, .el-button--info.is-disabled:hover
    background #D0CFCE
    border 1px solid #D0CFCE
  .item
    .row
      .el-input--medium .el-input__inner
        background $c7
  .error
    .el-input__inner
      border 1px solid $c10
      background-color rgba(255,57,35, 0.1)
  .el-dialog__body
    padding 0 24px 0 24px
</style>